import { useRef, useState } from 'react'
import { TFilters } from '../../../../../../../components/TableDataGridV2/types';
import { useFormContext } from 'react-hook-form';
import { Button, Stack } from '@mui/material';
import DisplayDadosClienteFormulario from '../../../../MIAnaliseDeCredito/DisplayDadosClienteFormulario';
import PreFiltros from '../../../PreFiltrosListagem';
import { headCellsTitulosPagar } from '../../../PreFiltrosListagem/dataGridConfig';
import { TableDataGridV2, TableDataGridRef } from '../../../../../../../components/TableDataGridV2';
import { enqueueSnackbar } from 'notistack';
export default function Step01({
  selected,
  handleChangeSelected
}: Step01Props) {

  const { getValues, setValue } = useFormContext();

  const preFilter = getValues('preFilterStep')
  const [preFilters, setPreFilters] = useState<TFilters>({})
  const tableRef = useRef<TableDataGridRef>(null)

  //funcoes manipuladoras
  const handleNext = () => {
    if (tableRef.current) {
      const selectedRows = tableRef.current.getSelectedRows();
      if (selectedRows.length === 0) {
        enqueueSnackbar('Por favor, selecione pelo menos um título.', { variant: 'warning' })
        return
      }

      const titulosMesmoPublico = selectedRows.every((row, index, array) => {
        if (index === 0) return true;
        return row.tipo_publico === array[0].tipo_publico &&
          row.codigo_publico === array[0].codigo_publico;
      });

      if (!titulosMesmoPublico) {
        enqueueSnackbar('Selecione apenas títulos do mesmo público.', { variant: 'warning' })
        return
      }

      handleChangeSelected(selectedRows)
      const nextStep = getValues('funcoesAux.onNext');
      nextStep();
    }
  };

  return (
    <>
      {
        preFilter &&
        <PreFiltros
          filtros={preFilters}
          onSubmitFilters={(values) => {
            setPreFilters(values)
            setValue('preFilterStep', false)
          }}
        />
      }

      {
        !preFilter &&
        <>
          {
            (preFilters?.tipo_publico_pesquisar && preFilters?.codigo_publico_pesquisar) &&
            <DisplayDadosClienteFormulario
              tipoDado='param'
              tipo={preFilters.tipo_publico_pesquisar}
              codigo={preFilters.codigo_publico_pesquisar}
            />
          }

          <TableDataGridV2
            ref={tableRef}
            columns={headCellsTitulosPagar}
            url="/financeiro/contas-pagar/pesquisar-titulos-pagar"
            queryKey="listar-todos-titulos-pagar"
            enableSelection={true}
            pagination="server"
            queryParams={{
              data_pagamento_is_null: true,
            }}
            preFilledFilters={preFilters}
            handleUpdatePreFilters={(value) => setPreFilters(value)}
            selectedFields={['id', 'tipo_publico', 'codigo_publico']}
          />

        </>
      }

      {
        !preFilter &&
        <Stack direction={'row'} justifyContent={'flex-end'} mt={1}>
          <Button
            variant="contained"
            onClick={() => {
              handleNext();
            }}
          >
            Avançar
          </Button>
        </Stack>
      }
    </>
  )
}

interface Step01Props {
  handleChangeSelected: (value: readonly string[]) => void
  selected: readonly string[]
}
